export let defaultCss = {
    // searchBox
    searchBox__container: "searchBox__container",
    searchBox__containerOpen: "searchBox__container--open",
    searchBox__input: "searchBox__input form-control",
    searchBox__suggestionsContainer: "searchBox__suggestions-container",
    searchBox__suggestionsList: "searchBox__suggestions-list",
    searchBox__suggestion: "searchBox__suggestion",
    searchBox__suggestionFocused: "searchBox__suggestion--focused",
    searchBox__sectionContainer: "searchBox__section-container",
    searchBox__sectionTitle: "searchBox__section-title",
    searchBox__inputContainer: "searchBox__input-container input-group",
    searchBox__buttonContainer: "searchBox__button-container input-group-btn",
    searchBox__button: "searchBox__button btn btn-default",
    searchBox__buttonIcon: "searchBox__button-icon glyphicon glyphicon-search",
    // faceting
    searchFacets__rangeFacet: "searchResults__rangeFacet panel-body",
    searchFacets__checkboxFacet: "searchResults__checkboxFacet panel-body",
    searchFacets__facetHeaderContainer: "searchResults__facetHeader-container panel-heading",
    searchFacets__facetHeader: "searchResults__facetHeader panel-title",
    searchFacets__facetHeaderLink: "searchResults__facetHeader-link",
    searchFacets__facetHeaderIconCollapsed: "searchResults__facetHeader-icon--collapsed indicator glyphicon glyphicon-triangle-right",
    searchFacets__facetHeaderIconOpen: "searchResults__facetHeader-icon--open indicator glyphicon glyphicon-triangle-bottom",
    searchFacets__facetControlContainer: "searchResults__facetControl-container panel-collapse collapse in",
    searchFacets__facetControlList: "searchResults__facetControl-list list-group",
    searchFacets__facetControl: "searchResults__facetControl list-group-item",
    searchFacets__facetControlCheckboxWrapper: "searchResults__facetControl-checkbox-wrapper checkbox",
    searchFacets__facetControlCheckboxChecked: "searchResults__facetControl-checkbox--checked",
    searchFacets__facetControlCheckboxCheckedHover: "searchResults__facetControl-checkbox--checkedHover",
    searchFacets__facetControlCheckboxUnchecked: "searchResults__facetControl-checkbox--unchecked",
    searchFacets__facetControlCheckboxUncheckedHover: "searchResults__facetControl-checkbox--uncheckedHover",
    searchFacets__facetControlCheckbox: "searchResults__facetControl-checkbox",
    searchFacets__facetControlRangeLabel: "searchResults__facetControl-rangeLabel list-group-item center-block text-center",
    searchFacets__facetControlRangeLabelMin: "searchResults__facetControl-rangeLabelMin",
    searchFacets__facetControlRangeLabelMax: "searchResults__facetControl-rangeLabelMax",
    searchFacets__facetControlRangeLabelRange: "searchResults__facetControl-rangeLabelRange",
    searchFacets__sliderContainer: "searchFacets__sliderContainer",
    searchFacets__clearFiltersButtonControl: "searchResults__clearFiltersButtonControl text-right",
    searchFacets__clearFiltersButtonDisabled: "text-muted",
    // sorting
    sorting__sortBy: "sorting__sortyBy panel-body",
    sorting__sortByControl: "sorting__sortyByControl list-group-item",
    // results
    searchResults__result: "searchResults__result col-xs-12 col-sm-12",
    results__blurb: "results__blurb row",
    // pager
    pager__pageItem: "pager__pageItem page-item",
    pager__pageItemActive: "pager__pageItemActive page-item active",
    pager__pageItemDisabled: "pager__pageItemDisabled page-item disabled",
    pager__pageLink: "pager__pageLink page-link",
    pager__list: "pager__list pagination",
    pager__nav: "pager__nav",
    // should be only visible to screen reader
    screenReaderOnly: "screenReaderOnly sr-only"
};


// WEBPACK FOOTER //
// ./src/utils/css.ts